export enum LossCertificateSettingOutcome {
  Unchanged = 0,
  Updated = 1,
  RemainingCases = 2,
  Failed = 3,
}
